module.exports = __webpack_public_path__ + "static/media/personalLoan.8b58fdad.svg";